// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ContentComponentItemFragmentDoc } from './ContentComponentItem.fragment.generated';
export const ComponentJobsJobFragmentDoc = gql`
    fragment componentJobsJob on Job {
  expandedByDefault
  title
  content {
    ...contentComponentItem
  }
  startDate
  closingDate
  postedDate
  location
  contractType
  salary
  vacancyReference
  applicationRecipientEmail
}
    ${ContentComponentItemFragmentDoc}`;